import type { FacilityConfig, FacilityDeliveryRules } from './types.js'

/** The API's defaults: texts on, no quiet hours, every type at the deployment's policy. */
export const DEFAULT_DELIVERY_RULES: FacilityDeliveryRules = { sms: { enabled: true, quietHours: null, types: {} } }

/** The facility's delivery rules with every field stated, for a configuration from an API deployed before they existed. */
export function deliveryRulesOf(config: Pick<FacilityConfig, 'delivery'> | null | undefined): FacilityDeliveryRules {
  const sms = config?.delivery?.sms
  return { sms: { enabled: sms?.enabled ?? true, quietHours: sms?.quietHours ?? null, types: { ...(sms?.types ?? {}) } } }
}
